module.exports = __webpack_public_path__ + "static/tampico-26c86a61910b807410a8995acff776e3.png";